import { useCallback, useState } from 'react';
import { useChainId } from 'src/hooks/chain';
import { useChangesSnackbar } from 'src/hooks/snackbar/useChangesSnackbar';
import { CreateChainFurnitureInput } from 'src/infrastructure/rest-api/api-types';
import { buildApiUrl, useApiMutation } from 'src/infrastructure/rest-api/useApi';

export const useInventoryMasterDataSaveChanges = () => {
    const chainId = useChainId();
    const showSnackbar = useChangesSnackbar();
    const [isUpdating, setIsUpdating] = useState(false);

    const [createFurniture] = useApiMutation('/api/inventorymanagement/chains/{chainId}', 'post', {
        update: (_data, variables, queryClient) => {
            queryClient.invalidateQueries({
                queryKey: [buildApiUrl('/api/inventorymanagement/chains/{chainId}', variables.path)],
            });
        },
    });

    const saveChanges = useCallback(
        async (input: CreateChainFurnitureInput) => {
            setIsUpdating(true);

            try {
                const response = await createFurniture({ path: { chainId: chainId }, body: input });
                showSnackbar();

                return response;
            } catch (err) {
                showSnackbar(err);
            } finally {
                setIsUpdating(false);
            }
        },
        [showSnackbar, createFurniture, chainId]
    );

    return [saveChanges, { loading: isUpdating }] as const;
};
